<template>
  <div>
    <transition name="fade-quick">
      <div v-if="$parent.loading" class="popup">
        <div class="offclick"></div>
        <div class="holder">
          <transition name="fade-quick">
            <div>
              <img class='popup-loader' src='https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/loader.gif?alt=media&token=1e9d8d95-bc15-4a88-bf64-de930f98a390'>
            </div>
          </transition>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>

export default {
  name: "loading",
  data() {
    return {
      
    };
  },
  methods: {
    
  },
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 199;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(53, 73, 94, 0.75);
}

.login-loader {
  height: 50px;
  display: block;
  width: auto !important;
}

.title {
  font-size: 30px;
  font-weight: bold;
  font-family: "SFProDisplay", sans-serif;
  margin-top: 0;
}

.offclick {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  height: 100%;
  width: 100%;
}

.holder {
  position: relative;
  padding: 0 !important;
  z-index: 2;
  padding: 0;
  background-color: white;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  overflow: auto;
}

.not_found .holder {
  max-height: 100%;
  overflow: auto;
}

.holder input {
  width: 100%;
  box-sizing: border-box;
}

.holder .txt_btn {
  font-size: 23px;
}

.thanks {
  text-align: center;
}

.loader {
  width: 200px !important;
  margin: auto;
}

.holder {
  padding: 50px;
}

.holder p {
  line-height: 1.2;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade_delay-enter-active,
.fade_delay-leave-active {
  transition: opacity 0.5s;
  transition-delay: 0.5s;
}
.fade_delay-enter, .fade_delay-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.close {
  font-size: 25px;
  font-weight: bold;
  opacity: 0.4;
  padding: 10px 20px;
  margin: 0;
  position: absolute;
  top: 0;
  right: 0;
  cursor: pointer;
}

.btns {
  width: 100%;
}

.error {
  text-align: left;
}
</style>
